
<form role="form" (ngSubmit)="onSubmit_changePhone(changePhoneForm)" #changePhoneForm="ngForm" aria-labelledby="aria_form_label">
  <h2 mat-dialog-title id="aria_form_label">{{ data.currentPhone ? 'Change' : 'Add' }} phone number</h2>
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>Country</mat-label>
      <mat-select [(value)]="changePhoneFormModel.country" #country
        (selectionChange)="onSelectionChange_determinePhoneMask()">
        <mat-select-trigger>
          <div class="change-phone-modal__trigger">
            <img class="country-flag" [src]="country.value?.flag" alt=""> +{{country.value?.dial_code}}
          </div>
        </mat-select-trigger>

        @for (country of countriesCodes; track country) {
          <mat-option [value]="country">
            <img class="country-flag" [src]="country.flag" alt=""> {{formatCountryCode(country)}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (userService.emailIsVerified$ | async) {
      <mat-form-field>
        <mat-label>Phone Number</mat-label>
        <input matInput
          [(ngModel)]="changePhoneFormModel.number"
          #numberModel="ngModel"
          name="Phone Number"
          inputmode="tel"
          maxlength="15"
          [mask]="currentMask"
          [showMaskTyped]="data.northAmerica">
          @if (numberModel.invalid) {
            <mat-error>{{validationService.getFieldErrorMessage(
              numberModel.name, numberModel, numberModel.name + ' must match the provided format.'
            )}}</mat-error>
          }
        </mat-form-field>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
      <button type="button" matButton mat-dialog-close>
        Cancel
      </button>
      <button type="submit" matButton>
        Save
      </button>
  </mat-dialog-actions>
</form>